<template>
  <article class="content">
    <h3 v-if="heading" class="heading--lg font-heading font-bold mb-1 px-2">
      {{ heading }}
    </h3>
    <a
      :href="url"
      class="relative block bike-overview-video"
      :data-video="url"
      data-ga-event="video-engagement"
      data-ga-category="Video Engagement"
      :data-ga-action="caption"
      data-ga-label="Play"
    >
      <image-component
        v-if="assetId"
        :asset-id="assetId"
        img-format="pjpg"
        aspect-ratio="16x9"
        transformation="fill"
        css-class="w-full h-full"
        :is-data-object-fit="true"
      />
      <pdl-icon
        size="48"
        name="play_circle_outline"
        class="text-white absolute top-[calc(50%-24px)] left-[calc(50%-24px)]"
        :label="$t('text.watch.video')"
      />
    </a>
  </article>
</template>

<script>
import ImageComponent from '@/components/ImageComponent';
import {PdlIcon} from '@pedal/pdl-icon';

export default {
  components: {ImageComponent, PdlIcon},
  props: {
    assetId: {
      type: String,
      default: () => '',
    },
    url: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      default: () => '',
    },
    heading: {
      type: String,
      default: () => '',
    },
  },
};
</script>
<style lang="scss" scoped>
.bike-overview-video :deep(picture) {
  @media (screen(xl)) {
    max-height: calc(85vh - var(--header-height));
    min-width: 100%;
  }
}
</style>
